// extracted by mini-css-extract-plugin
export default {"link":"xK-z","disabled":"yK-z"};